import React from "react";

import "./styles.scss";

interface Props {
  label?: string;
  onClick?: (val: any) => void;
  checked?: boolean;
  style?: any;
}

const Checkbox = ({ label, onClick, checked, style }: Props) => {
  return (
    <div className="checkBox">
      <label className="custom-checkbox">
        <input
          type="checkbox"
          value={label}
          onClick={(e) => {
            onClick && onClick(e);
          }}
          onChange={() => null}
          checked={checked}
        />
        <span
          style={{
            fontWeight: 500,
            fontSize: 20,
            ...style
          }}>
          {label}
        </span>
      </label>
    </div>
  );
};

export default Checkbox;
